import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
} from '@angular/core';
import { BaseMapComponent } from '../../../global/map/base-map.component';
import { AuthenticationService } from '../../../../core/authentication.service';
import { TranslateService } from '@ngx-translate/core';
import { ScriptService } from '../../../../core/script.service';
import { TypedSimpleChanges } from '../../../../utils/typescript';
import { Location } from '../../../../models/locations-models/location';
import { BlsGmbDifferenceMapService } from './bls-gmb-differences-map.service';
import { PushPipe } from '@ngrx/component';

// TODO: Refactor using gmaps components, get rid of UUID

@Component({
    selector: 'app-bls-gmb-differences-map',
    templateUrl: './bls-gmb-differences-map.html',
    // the standard map's scss because it already includes everything we need
    styleUrls: ['../../../global/map/map.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
  imports: [PushPipe],
})
export class BlsGmbDifferencesMapComponent extends BaseMapComponent implements OnDestroy {

  @Input() locations: Location[];

  constructor(
      public authService: AuthenticationService,
      protected translate: TranslateService,
      protected scriptService: ScriptService,
      protected changeDetector: ChangeDetectorRef,
      private gmbDiffMapService: BlsGmbDifferenceMapService,
  ) {
    super(authService, translate, scriptService, changeDetector, gmbDiffMapService);
  }

  initLogic() {
    // setTimeout to prevent sporadic map undefined errors
    setTimeout(() => {
      this.gmbDiffMapService
          .setMap(this.map)
          .renderLocationMarkers(this.locations);
    });
  }

  protected shouldReloadMarkersOnNgChanges(changes: TypedSimpleChanges<BlsGmbDifferencesMapComponent>): boolean {
    // Map should be updated when locations change, but each CD cycle calls getMapConfig() which returns
    // a new object that will contain the same locations unless the user progressed to another difference
    // Not having this check needlessly re-renders markers and breaks the 'minimize map pin' feature
    let reload = false;
    changes.locations.previousValue.forEach((location, i) => {
      // amount of locations should be always the same, so check just the coords
      if (location.coordinate.latitude !== changes.locations.currentValue[i].coordinate.latitude ||
          location.coordinate.longitude !== changes.locations.currentValue[i].coordinate.longitude) {
        reload = true;
      }
    })
    return reload;
  }

  ngOnDestroy() {
    this.gmbDiffMapService.flushMap();
  }

}
